import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../mockData';
import { Calendar, User, ArrowRight } from 'lucide-react';

const Blog = () => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const categories = [...new Set(blogPosts.map(post => post.category))];

  return (
    <div className="page-container">
      {/* Blog Hero */}
      <section className="blog-hero-section">
        <div className="container">
          <h1 className="heading-1">INSIGHTS & PERSPECTIVES</h1>
          <p className="body-large max-w-4xl">
            Explore our thoughts on digital communication, responsible AI, strategic marketing, 
            and the future of media. Industry insights from our team of experts.
          </p>
        </div>
      </section>

      {/* Categories */}
      <section className="categories-section">
        <div className="container">
          <div className="categories-list">
            <button className="category-tag active">All Posts</button>
            {categories.map((category, index) => (
              <button key={index} className="category-tag">
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="section-padding">
        <div className="container">
          <div className="blog-grid">
            {blogPosts.map((post) => (
              <article key={post.id} className="blog-card">
                <div className="blog-card-image">
                  <img src={post.image} alt={post.title} />
                  <div className="blog-category-badge">{post.category}</div>
                </div>
                <div className="blog-card-content">
                  <div className="blog-meta">
                    <span className="blog-meta-item">
                      <Calendar size={14} />
                      {formatDate(post.date)}
                    </span>
                    <span className="blog-meta-item">
                      <User size={14} />
                      {post.author}
                    </span>
                  </div>
                  <h3 className="heading-5 blog-title">{post.title}</h3>
                  <p className="body-small blog-excerpt">{post.excerpt}</p>
                  <button className="blog-read-more">
                    Read More <ArrowRight size={16} />
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="newsletter-section">
        <div className="container">
          <div className="newsletter-content">
            <h2 className="heading-2">STAY UPDATED</h2>
            <p className="body-large">
              Subscribe to our newsletter for the latest insights on digital communication, 
              AI in marketing, and industry trends.
            </p>
            <form className="newsletter-form" onSubmit={(e) => {
              e.preventDefault();
              alert('Newsletter subscription coming soon!');
            }}>
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter-input"
                required
              />
              <button type="submit" className="btn-primary">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Featured Topics */}
      <section className="section-padding bg-card">
        <div className="container">
          <h2 className="heading-2 text-center mb-96">TOPICS WE COVER</h2>
          <div className="topics-grid">
            <div className="topic-item">
              <h3 className="heading-5">AI & Technology</h3>
              <p className="body-small">
                Responsible AI integration, machine learning in marketing, and emerging 
                communication technologies.
              </p>
            </div>
            <div className="topic-item">
              <h3 className="heading-5">Communication Strategy</h3>
              <p className="body-small">
                Strategic frameworks, narrative building, stakeholder engagement, and 
                brand communication excellence.
              </p>
            </div>
            <div className="topic-item">
              <h3 className="heading-5">Digital Marketing</h3>
              <p className="body-small">
                Data-driven marketing, campaign optimization, audience insights, and 
                ROI measurement strategies.
              </p>
            </div>
            <div className="topic-item">
              <h3 className="heading-5">Industry Trends</h3>
              <p className="body-small">
                Market analysis, sector-specific insights, regulatory updates, and 
                future predictions for media and communication.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Blog;
